import { useAuthStore } from '@/stores/auth-store';
import { DashboardLayout } from '@/components/ui/dashboard-layout';
import { ErrorPage } from '@/components/ui/error-page';

export function NotFoundPage() {
  const { isAuthenticated } = useAuthStore();

  if (isAuthenticated) {
    return (
      <DashboardLayout>
        <ErrorPage status={404} />
      </DashboardLayout>
    );
  }

  return <ErrorPage status={404} standalone />;
}
